import React, { Children, cloneElement } from 'react';

import { SxProps } from '@mui/material';
import clsx from 'clsx';
import { DatagridClasses, RaRecord, RecordContextProvider, RowClickFunction } from 'react-admin';
import { TableBody } from 'shared/mui/Table';

type Props = {
  bodyRef: React.RefObject<HTMLTableSectionElement>;
  bottomPadding: number;
  children?: React.ReactNode;
  data?: RaRecord[];
  measureElement: (element: HTMLElement | null) => void;
  resource?: string;
  row: React.ReactElement;
  rowClick?: RowClickFunction;
  rowSx?: (record: RaRecord, index: number) => SxProps;
  startIndex: number;
  topPadding: number;
};

const SPACER_CELL_STYLE = { border: 0, padding: 0 };

export const BalanceReportDatagridBody: React.FC<Props> = ({
  bodyRef,
  bottomPadding,
  children,
  data = [],
  measureElement,
  resource,
  row,
  rowClick,
  rowSx,
  startIndex,
  topPadding,
}) => {
  const columnsCount = Children.count(children);

  return (
    <TableBody className={clsx('datagrid-body', DatagridClasses.tbody)} ref={bodyRef}>
      {topPadding > 0 && (
        <tr aria-hidden="true" style={{ height: `${topPadding}px` }}>
          <td colSpan={columnsCount} style={SPACER_CELL_STYLE} />
        </tr>
      )}
      {data.map((record, index) => (
        <RecordContextProvider key={record.id} value={record}>
          {cloneElement(
            row,
            {
              className: DatagridClasses.row,
              'data-index': startIndex + index,
              id: record.id,
              ref: measureElement,
              resource,
              rowClick,
              sx: rowSx?.(record, index),
            },
            children,
          )}
        </RecordContextProvider>
      ))}
      {bottomPadding > 0 && (
        <tr aria-hidden="true" style={{ height: `${bottomPadding}px` }}>
          <td colSpan={columnsCount} style={SPACER_CELL_STYLE} />
        </tr>
      )}
    </TableBody>
  );
};
